const STATUS_TOOLTIP_LINE_MAX = 100;
const BREAK_ACCENT_COLOR = '#f00080';

function truncateStatusLine(text, max) {
    const t = String(text || '').trim();
    if (!t)
        return '';
    if (t.length <= max)
        return t;
    return `${t.slice(0, Math.max(1, max - 1))}\u2026`;
}

/**
 * Abbreviated SVG tooltip for a cell's compile errors.
 * Prefers `ArgName: Message`; one line, or two lines plus `(+N more)`.
 * @param {Array<{ ArgName?: string, Message?: string }>} errors
 * @returns {string}
 */
function formatStatusTooltip(errors) {
    if (!Array.isArray(errors) || !errors.length)
        return '';
    const lines = [];
    const seen = new Set();
    for (const err of errors) {
        if (!err)
            continue;
        const msg = String(err.Message || '').trim();
        const arg = err.ArgName != null ? String(err.ArgName).trim() : '';
        const raw = arg && msg ? `${arg}: ${msg}` : (msg || arg);
        if (!raw || seen.has(raw))
            continue;
        seen.add(raw);
        lines.push(truncateStatusLine(raw, STATUS_TOOLTIP_LINE_MAX));
    }
    if (!lines.length)
        return '';
    if (lines.length === 1)
        return lines[0];
    const shown = lines.slice(0, 2);
    const more = lines.length - 2;
    if (more > 0)
        shown.push(`(+${more} more)`);
    return shown.join('\n');
}

function isBreakpointVisible(element) {
    return element?.attr?.('breakAccent/visibility') === 'visible';
}

export {
    formatStatusTooltip,
    isBreakpointVisible,
    STATUS_TOOLTIP_LINE_MAX,
    BREAK_ACCENT_COLOR,
};
